// Basemap: OpenFreeMap vector tiles (free, keyless, unlimited) rendered
// through MapLibre GL inside Leaflet. Replaced Mapbox raster Static Tiles
// (Sep 2026) after a $163/mo tile bill — raster tiles bill per request,
// OpenFreeMap is $0. Mapbox token remains for geocoding only.
import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { setWorkerUrl } from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "@maplibre/maplibre-gl-leaflet";

// CRA's webpack/babel pipeline breaks MapLibre's bundled worker URL
// ("Worker failed to load") — serve the worker from our own origin instead.
// Served as .js (not .mjs) so every host/WebView returns a JS MIME type.
// Files are copied from node_modules into public/ (see yarn postinstall).
try { setWorkerUrl("/maplibre-gl-worker.js"); } catch { /* older api */ }

const OFM_LIGHT = "https://tiles.openfreemap.org/styles/liberty";
const OFM_DARK = "https://tiles.openfreemap.org/styles/dark";

export function GlBasemap({ dark = false }) {
  const map = useMap();
  useEffect(() => {
    const layer = L.maplibreGL({
      style: dark ? OFM_DARK : OFM_LIGHT,
      attribution: BASEMAP_ATTRIBUTION,
    });
    layer.addTo(map);
    return () => {
      try { map.removeLayer(layer); } catch { /* map already gone */ }
    };
  }, [map, dark]);
  return null;
}

// Keyless raster fallback for anything still on <TileLayer>.
export function basemapTileUrl() {
  return "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
}

export const BASEMAP_ATTRIBUTION =
  '© <a href="https://openfreemap.org">OpenFreeMap</a> © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';
